import { isBoolean } from 'lodash';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import StorageService from 'services/StorageService';

const useToggleDialog = (bool) => {
  const [open, setOpen] = useState(isBoolean(bool) ? bool : false);
  const [close, setClose] = useState(isBoolean(bool) ? bool : false);
  const timerOnClickHandler = useRef(null);

  useEffect(() => {
    if (open) {
      timerOnClickHandler.current = setTimeout(() => {
        const modals = document.querySelectorAll('.modal');
        if (modals.length > 0) {
          modals.forEach((modalEl) => {
            modalEl.addEventListener('click', (e) => {
              StorageService.handleElementClicked(e);
            });
          });
        }
      }, 300);

      //* [FIX SOMETIME CANNOT SCROLL IN DIALOG] - Add modal-open className to body classList if it not have yet
      setTimeout(() => {
        const body = document.body;
        if (!body.className.includes('modal-open')) {
          body.classList.add('modal-open');
        }
      }, 100);
    }

    return () => {
      clearTimeout(timerOnClickHandler.current);
    };
  }, [open]);

  const clearModalOpen = useCallback(() => {
    setTimeout(() => {
      setClose((close) => !close);
      /**
       * Fix freeze bug - user cannot scroll
       */
      // Check if modal exist, remove class modal-open
      const noModalExist = document.querySelectorAll("body > div[tabindex='-1']")?.length === 0;
      if (noModalExist) {
        console.log('%cNo modal? =>> remove modal-open', 'color: green');
        document.body.classList.remove('modal-open');
      }
    }, 500);
  }, []);

  const toggle = useCallback(
    (bool) => {
      if (typeof bool === 'boolean') {
        setOpen(bool);
        clearModalOpen();
        return;
      }

      setOpen((open) => !open);
      clearModalOpen();
    },
    [clearModalOpen]
  );

  const shouldRender = useMemo(() => {
    return open || close;
  }, [open, close]);

  return [open, toggle, shouldRender];
};

export default useToggleDialog;
